import type { Test } from '@/data'
import api from '..'

export async function getTest(id: string): Promise<Test> {
  const res = await api.get(`/flow_experiments/${id}`)
  return res.data.data
}
